"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchers = void 0;
var UserRegionActions = require("@caddigital/sok-reducers/lib/actions/user/region");
var UserSettingsActions = require("@caddigital/sok-reducers/lib/actions/user/userSettings");
var mapDispatchers = function (dispatch) { return ({
    changeTab: function (index) { return dispatch(UserSettingsActions.changeTab(index)); },
    close: function (actions) { return function () {
        return dispatch(UserSettingsActions.closeUserSettingsModal(actions));
    }; },
    fetchRegions: function () { return dispatch(UserRegionActions.fetchRequest()); },
    fetchUserConsents: function (userId) {
        return void dispatch(UserSettingsActions.fetchOrUpdateUserConsentsRequest(userId));
    },
    saveProfile: function () { return dispatch(UserSettingsActions.updateMemberInfoRequest()); },
    save: function (user, customer) {
        return customer
            ? dispatch(UserSettingsActions.updateUserCompany(user, customer.uuid))
            : dispatch(UserSettingsActions.updateEmail());
    },
    updateUserConsents: function (userId, consents) {
        return void dispatch(UserSettingsActions.fetchOrUpdateUserConsentsRequest(userId, consents));
    }
}); };
exports.mapDispatchers = mapDispatchers;
